import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";

import { useEffect, useState } from "react";
import { fetchDataEngine } from "../../../data/Axios/DynamicService";

import {
    imprestApplicationsByUser,
  imprestApplicationsPendingDisbursement,
  leaveApplications,
  leaveApplicationsByUser,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import { LeaveApplicationsColumns, imprestApplicationsColumns, imprestApplicationsPendingDisbursementColumns } from "../../../data/Columns/hrmanagement";
import { HRService } from "../../../config";
import ImprestApplicationForm from "./form";
import ImprestDocumentsDrawer from "./ImprestDocumentsDrawer";

const base_url = HRService.uri;

function ImprestPendingDisbursementTable() {
  const [docsDrawerOpen, setDocsDrawerOpen] = useState(false);
  const [selectedRecordForDocs, setSelectedRecordForDocs] = useState(null);

  const actions = {
  entity: "Imprests Pending Disbursement",

  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: false,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: false,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },

  DISBURSEIMPREST: {
    key: "DISBURSEIMPREST",
    button_name: "Disburse",
    // Show only when the row is APPROVED (statusId = 3)
    Show_Button: (row) => row.statusId === 3,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },

    ViewImprestLines: {
      key: "ViewImprestLines",
      button_name: "View Lines",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    ViewDocuments: {
      key: "ViewDocuments",
      button_name: "View Documents",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
      onClick: (row) => {
        setSelectedRecordForDocs(row);
        setDocsDrawerOpen(true);
      },
    },

  showStatus: true,
};

  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Imprest Pending Disbursement"
          subtitle="View all your Imprest , create or update it"
          columns={imprestApplicationsPendingDisbursementColumns}
         // FormComponent={ImprestApplicationForm}
          query={imprestApplicationsPendingDisbursement}
          actions={actions}
          base_url={base_url}
        />
        <ImprestDocumentsDrawer
          open={docsDrawerOpen}
          onClose={() => {
            setDocsDrawerOpen(false);
            setSelectedRecordForDocs(null);
          }}
          imprestId={selectedRecordForDocs?.id}
        />
      </>
    </Box>
  );
}

export default ImprestPendingDisbursementTable;
